var exports = {
  "b": "ComparisonContainer__M-bS0n",
  "Tb": "ComparisonHeader__UXuCLP",
  "SN": "ComparisonTitle__fXpKKi",
  "xk": "ComparisonContent__nE-jdI",
  "Wx": "LeftPanel__-dfWF_",
  "p": "RightPanel__WJOnmb",
  "H8": "UserAvatar__H85wUX",
  "j0": "AvatarContainer__povtSV",
  "tE": "ViewChangesButton__7ZNYbv",
  "i$": "ChangesSummary__uT1XFm",
  "N2": "ChangesContainer__WQZ02J",
};

module.exports = exports;
